module.exports = __webpack_public_path__ + "static/media/CGC Vertical Transportation Booklet.4751be76.pdf";